// Web Audio ambient sound generator - no external files needed
let ctx = null;
let nodes = [];

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
}

function makeNoiseBuffer(c) {
  const bufferSize = 2 * c.sampleRate;
  const buffer = c.createBuffer(1, bufferSize, c.sampleRate);
  const data = buffer.getChannelData(0);
  let last = 0;
  for (let i = 0; i < bufferSize; i++) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02; // brown noise
    data[i] = last * 3.5;
  }
  return buffer;
}

export function stopAmbient() {
  nodes.forEach((n) => { try { n.stop ? n.stop() : n.disconnect(); } catch {} });
  nodes = [];
}

export function playAmbient(type) {
  stopAmbient();
  const c = getCtx();
  if (c.state === "suspended") c.resume();

  const src = c.createBufferSource();
  src.buffer = makeNoiseBuffer(c);
  src.loop = true;

  const filter = c.createBiquadFilter();
  const gain = c.createGain();

  if (type === "rain") {
    filter.type = "highpass"; filter.frequency.value = 800; gain.gain.value = 0.5;
  } else if (type === "ocean") {
    filter.type = "lowpass"; filter.frequency.value = 500; gain.gain.value = 0.6;
    const lfo = c.createOscillator(); const lfoGain = c.createGain();
    lfo.frequency.value = 0.12; lfoGain.gain.value = 0.25;
    lfo.connect(lfoGain); lfoGain.connect(gain.gain); lfo.start(); nodes.push(lfo);
  } else if (type === "forest") {
    filter.type = "bandpass"; filter.frequency.value = 1200; gain.gain.value = 0.35;
  } else { // calm
    filter.type = "lowpass"; filter.frequency.value = 350; gain.gain.value = 0.4;
  }

  src.connect(filter); filter.connect(gain); gain.connect(c.destination);
  src.start();
  nodes.push(src, filter, gain);
}
